module.exports = __webpack_public_path__ + "img/CAPTAIN_BIKE_0_RIGHT.b41970ad.png";